<template>

  <!-- 最新年度の実績 -->
  <div>

    <!-- 実績値エラー表示 -->
    <div class="l-contentsSection error" 
      v-if="
      $v.workingAverage.achievementWorkingHoursAverage.$invalid || 
      $v.workingAverage.regularWorkingHours.$invalid
      || (errorStatusRegularCount) // 正社員カウントエラー
      || (errorStatusNonRegularCount) // 非正規社員カウントエラー
      || (errorStatusLegalOutsideOvertime) // 法定外残業エラー
      || (errorStatusLegalHolidayAttendance) // 法定休日出勤エラー
      || $v.workingAverage.resultMemo.$invalid 
      || $v.workingAverage.actionMemo.$invalid">
      <div v-if="$v.workingAverage.achievementWorkingHoursAverage.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">平均残業時間：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.workingAverage.achievementWorkingHoursAverage.$invalid && !$v.workingAverage.achievementWorkingHoursAverage.customDoubleNum" validation="customDoubleNum" valueInt="3" valueDouble="1"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.workingAverage.achievementWorkingHoursAverage.$invalid && $v.workingAverage.achievementWorkingHoursAverage.customDoubleNum && !$v.workingAverage.achievementWorkingHoursAverage.between" validation="between" valueMin="0" valueMax="999.9"/>
      </div>
      <div v-if="$v.workingAverage.regularWorkingHours.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">正社員1日所定労働時間：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.workingAverage.regularWorkingHours.$invalid && !$v.workingAverage.regularWorkingHours.customDoubleNum" validation="customDoubleNum" valueInt="1" valueDouble="2"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.workingAverage.regularWorkingHours.$invalid && $v.workingAverage.regularWorkingHours.customDoubleNum && !$v.workingAverage.regularWorkingHours.between" validation="between" valueMin="0" valueMax="9.99"/>
      </div>

      <!-- 正社員（人数）　エラーメッセージ表示 -->
      <div v-if="errorStatusRegularCount" style="padding-bottom:5px;">
        <!-- 数値チェック -->
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">正社員（人数）　　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="errorStatusRegularCount && !errorStatusRegularCountNumeric" validation="numeric"/>
        <span v-for="(item,index) in this.errObjRegularCountArr" :key="item.num">
          <span style="color:red; font-size: 1.5rem;margin-left: 20px;" v-show="item.$invalid && !item.numeric">
            {{monthArr[index]+'月'}}
          </span>
        </span>
        <!-- 数値範囲チェック -->
        <ValidationErrorMessage style="margin-left:20px;" v-show="errorStatusRegularCount && errorStatusRegularCountNumeric && !errorStatusRegularCountBetween" validation="between" valueMin="0" valueMax="99999"/>
        <span v-for="(item,index) in this.errObjRegularCountArr" :key="item.num">
          <span style="color:red; font-size: 1.5rem;margin-left: 20px;" v-show="item.$invalid && errorStatusRegularCountNumeric && !item.between">
            {{monthArr[index]+'月'}}
          </span>
        </span>
      </div>

      <!-- 非正規社員（人数）　エラーメッセージ表示 -->
      <div v-if="errorStatusNonRegularCount" style="padding-bottom:5px;">
        <!-- 数値チェック -->
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">非正規員（人数）　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="errorStatusNonRegularCount && !errorStatusNonRegularCountNumeric" validation="numeric"/>
        <span v-for="(item,index) in this.errObjNonRegularCountArr" :key="item.num">
          <span style="color:red; font-size: 1.5rem;margin-left: 20px;" v-show="item.$invalid && !item.numeric">
            {{monthArr[index]+'月'}}
          </span>
        </span>
        <!-- 数値範囲チェック -->
        <ValidationErrorMessage style="margin-left:20px;" v-show="errorStatusNonRegularCount && errorStatusNonRegularCountNumeric && !errorStatusNonRegularCountBetween" validation="between" valueMin="0" valueMax="99999"/>
        <span v-for="(item,index) in this.errObjNonRegularCountArr" :key="item.num">
          <span style="color:red; font-size: 1.5rem;margin-left: 20px;" v-show="item.$invalid && errorStatusNonRegularCountNumeric && !item.between">
            {{monthArr[index]+'月'}}
          </span>
        </span>
      </div>
      <!-- 法定外残業（時間）　エラーメッセージ表示 -->
      <div v-if="errorStatusLegalOutsideOvertime" style="padding-bottom:5px;">
        <!-- 数値チェック -->
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">法定外残業（時間）　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="errorStatusLegalOutsideOvertime && !errorStatusLegalOutsideOvertimeNumeric" validation="numeric"/>
        <span v-for="(item,index) in this.errObjLegalOutsideOvertimeArr" :key="item.num">
          <span style="color:red; font-size: 1.5rem;margin-left: 20px;" v-show="item.$invalid && !item.numeric">
            {{monthArr[index]+'月'}}
          </span>
        </span>
        <!-- 数値範囲チェック -->
        <ValidationErrorMessage style="margin-left:20px;" v-show="errorStatusLegalOutsideOvertime && errorStatusLegalOutsideOvertimeNumeric && !errorStatusLegalOutsideOvertimeBetween" validation="between" valueMin="0" valueMax="9999999"/>
        <span v-for="(item,index) in this.errObjLegalOutsideOvertimeArr" :key="item.num">
          <span style="color:red; font-size: 1.5rem;margin-left: 20px;" v-show="item.$invalid && errorStatusLegalOutsideOvertimeNumeric && !item.between">
            {{monthArr[index]+'月'}}
          </span>
        </span>
      </div>
      <!-- 法定休日出勤（時間）　エラーメッセージ表示 -->
      <div v-if="errorStatusLegalHolidayAttendance" style="padding-bottom:5px;">
        <!-- 数値チェック -->
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">法定休日出勤（時間）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="errorStatusLegalHolidayAttendance && !errorStatusLegalHolidayAttendanceNumeric" validation="numeric"/>
        <span v-for="(item,index) in this.errObjLegalHolidayAttendanceArr" :key="item.num">
          <span style="color:red; font-size: 1.5rem;margin-left: 20px;" v-show="item.$invalid && !item.numeric">
            {{monthArr[index]+'月'}}
          </span>
        </span>
        <!-- 数値範囲チェック -->
        <ValidationErrorMessage style="margin-left:20px;" v-show="errorStatusLegalHolidayAttendance && errorStatusLegalHolidayAttendanceNumeric && !errorStatusLegalHolidayAttendanceBetween" validation="between" valueMin="0" valueMax="9999999"/>
        <span v-for="(item,index) in this.errObjLegalHolidayAttendanceArr" :key="item.num">
          <span style="color:red; font-size: 1.5rem;margin-left: 20px;" v-show="item.$invalid && errorStatusLegalHolidayAttendanceNumeric && !item.between">
            {{monthArr[index]+'月'}}
          </span>
        </span>
      </div>
      <div v-if="$v.workingAverage.resultMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">実績に関するメモ　　　　：</span>
        <ValidationErrorMessage v-show="$v.workingAverage.resultMemo.$invalid && !$v.workingAverage.resultMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
      <div v-if="$v.workingAverage.actionMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">具体的なアクション　　　：</span>
        <ValidationErrorMessage v-show="$v.workingAverage.actionMemo.$invalid && !$v.workingAverage.actionMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
    </div>

    <!-- 実績値入力 -->
      <p class="l-formGroup__label u-mb10">残業時間 / 休日出勤時間</p>
      <div class="human-capitalt-data-wrap__table-full">
        <table class="human-capitalt-data-table is-narrow">
          <colgroup>
            <col>
            <col style="width: 90px;">
            <col style="width: 90px;">
            <col style="width: 90px;">
            <col style="width: 90px;">
            <col style="width: 90px;">
            <col style="width: 90px;">
            <col style="width: 90px;">
            <col style="width: 90px;">
            <col style="width: 90px;">
            <col style="width: 90px;">
            <col style="width: 90px;">
            <col style="width: 90px;">
            <col style="width: 90px;">
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>{{this.monthArr[0]}}月</th>
              <th>{{this.monthArr[1]}}月</th>
              <th>{{this.monthArr[2]}}月</th>
              <th>{{this.monthArr[3]}}月</th>
              <th>{{this.monthArr[4]}}月</th>
              <th>{{this.monthArr[5]}}月</th>
              <th>{{this.monthArr[6]}}月</th>
              <th>{{this.monthArr[7]}}月</th>
              <th>{{this.monthArr[8]}}月</th>
              <th>{{this.monthArr[9]}}月</th>
              <th>{{this.monthArr[10]}}月</th>
              <th>{{this.monthArr[11]}}月</th>
              <th>合計</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>正社員（人数）</th>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.regularCount1" type="text" name="workingAverage.regularCount1" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.regularCount2" type="text" name="workingAverage.regularCount2" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.regularCount3" type="text" name="workingAverage.regularCount3" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.regularCount4" type="text" name="workingAverage.regularCount4" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.regularCount5" type="text" name="workingAverage.regularCount5" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.regularCount6" type="text" name="workingAverage.regularCount6" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.regularCount7" type="text" name="workingAverage.regularCount7" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.regularCount8" type="text" name="workingAverage.regularCount8" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.regularCount9" type="text" name="workingAverage.regularCount9" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.regularCount10" type="text" name="workingAverage.regularCount10" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.regularCount11" type="text" name="workingAverage.regularCount11" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.regularCount12" type="text" name="workingAverage.regularCount12" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td><span class="human-capitalt-data-table__text"><Currency :value="sumOfRegularCount"/></span></td>
            </tr>
            <tr>
              <th>非正規社員（人数）</th>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.nonRegularCount1" type="text" name="workingAverage.nonRegularCount1" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.nonRegularCount2" type="text" name="workingAverage.nonRegularCount2" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.nonRegularCount3" type="text" name="workingAverage.nonRegularCount3" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.nonRegularCount4" type="text" name="workingAverage.nonRegularCount4" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.nonRegularCount5" type="text" name="workingAverage.nonRegularCount5" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.nonRegularCount6" type="text" name="workingAverage.nonRegularCount6" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.nonRegularCount7" type="text" name="workingAverage.nonRegularCount7" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.nonRegularCount8" type="text" name="workingAverage.nonRegularCount8" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.nonRegularCount9" type="text" name="workingAverage.nonRegularCount9" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.nonRegularCount10" type="text" name="workingAverage.nonRegularCount10" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.nonRegularCount11" type="text" name="workingAverage.nonRegularCount11" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input">
                  <TextBox v-model.trim="$v.workingAverage.$model.nonRegularCount12" type="text" name="workingAverage.nonRegularCount12" class="u-tac" @input="changeInput()" ></TextBox>
                </div>
              </td>
              <td><span class="human-capitalt-data-table__text"><Currency :value="this.sumOfNonRegularCount"/></span></td>
            </tr>
            <tr class="human-capitalt-data-table__bordertop">
              <th>法定外残業（時間）</th>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalOutsideOvertime1" type="text" name="workingAverage.legalOutsideOvertime1" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalOutsideOvertime2" type="text" name="workingAverage.legalOutsideOvertime2" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalOutsideOvertime3" type="text" name="workingAverage.legalOutsideOvertime3" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalOutsideOvertime4" type="text" name="workingAverage.legalOutsideOvertime4" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalOutsideOvertime5" type="text" name="workingAverage.legalOutsideOvertime5" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalOutsideOvertime6" type="text" name="workingAverage.legalOutsideOvertime6" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalOutsideOvertime7" type="text" name="workingAverage.legalOutsideOvertime7" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalOutsideOvertime8" type="text" name="workingAverage.legalOutsideOvertime8" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalOutsideOvertime9" type="text" name="workingAverage.legalOutsideOvertime9" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalOutsideOvertime10" type="text" name="workingAverage.legalOutsideOvertime10" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalOutsideOvertime11" type="text" name="workingAverage.legalOutsideOvertime11" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalOutsideOvertime12" type="text" name="workingAverage.legalOutsideOvertime12" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td><span class="human-capitalt-data-table__text"><Currency :value="this.sumOfLegalOutsideOvertime" /></span></td>
            </tr>
            <tr>
              <th>法定休日出勤（時間）</th>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalHolidayAttendance1" type="text" name="workingAverage.legalHolidayAttendance1" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalHolidayAttendance2" type="text" name="workingAverage.legalHolidayAttendance2" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalHolidayAttendance3" type="text" name="workingAverage.legalHolidayAttendance3" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalHolidayAttendance4" type="text" name="workingAverage.legalHolidayAttendance4" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalHolidayAttendance5" type="text" name="workingAverage.legalHolidayAttendance5" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalHolidayAttendance6" type="text" name="workingAverage.legalHolidayAttendance6" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalHolidayAttendance7" type="text" name="workingAverage.legalHolidayAttendance7" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalHolidayAttendance8" type="text" name="workingAverage.legalHolidayAttendance8" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalHolidayAttendance9" type="text" name="workingAverage.legalHolidayAttendance9" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalHolidayAttendance10" type="text" name="workingAverage.legalHolidayAttendance10" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalHolidayAttendance11" type="text" name="workingAverage.legalHolidayAttendance11" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input is-wide">
                  <TextBox v-model.trim="$v.workingAverage.$model.legalHolidayAttendance12" type="text" name="workingAverage.legalHolidayAttendance12" class="u-tac" @input="changeInput()"></TextBox>
                </div>
              </td>
              <td><span class="human-capitalt-data-table__text"><Currency :value="this.sumOfLegalHolidayAttendance"/></span></td>
            </tr>
            <tr>
              <th>平均残業（時間）</th>
                <td><span class="human-capitalt-data-table__text"><Currency :value="this.calcWorkingAverage(0)" /></span></td>
                <td><span class="human-capitalt-data-table__text"><Currency :value="this.calcWorkingAverage(1)" /></span></td>
                <td><span class="human-capitalt-data-table__text"><Currency :value="this.calcWorkingAverage(2)" /></span></td>
                <td><span class="human-capitalt-data-table__text"><Currency :value="this.calcWorkingAverage(3)" /></span></td>
                <td><span class="human-capitalt-data-table__text"><Currency :value="this.calcWorkingAverage(4)" /></span></td>
                <td><span class="human-capitalt-data-table__text"><Currency :value="this.calcWorkingAverage(5)" /></span></td>
                <td><span class="human-capitalt-data-table__text"><Currency :value="this.calcWorkingAverage(6)" /></span></td>
                <td><span class="human-capitalt-data-table__text"><Currency :value="this.calcWorkingAverage(7)" /></span></td>
                <td><span class="human-capitalt-data-table__text"><Currency :value="this.calcWorkingAverage(8)" /></span></td>
                <td><span class="human-capitalt-data-table__text"><Currency :value="this.calcWorkingAverage(9)" /></span></td>
                <td><span class="human-capitalt-data-table__text"><Currency :value="this.calcWorkingAverage(10)"/></span></td>
                <td><span class="human-capitalt-data-table__text"><Currency :value="this.calcWorkingAverage(11)"/></span></td>
                <td><span class="human-capitalt-data-table__text"><Currency :value="this.calcWorkingAverage()" /></span></td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table-full-->

      <div class="human-capitalt-data-wrap__arrow is-down"></div>

      <div class="human-capitalt-data-wrap__results is-100">
        <div class="human-capitalt-data-results">
          <div class="human-capitalt-data-results__text is-center">
            平均残業時間
            <strong><Currency  :value="this.calcWorkingAverage()"/></strong>時間
            <div class="is-flex">
              <span>正社員1日所定労働時間</span>
              <div class="human-capitalt-data-table__input has-unit">
                <TextBox v-model.trim="$v.workingAverage.$model.regularWorkingHours" type="text" name="workingAverage.regularWorkingHours" class="u-tac" @input="changeInput()"></TextBox>
                <span class="human-capitalt-data-table__unit">時間</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
            <p v-if="this.num==0" class="l-memo-note">現状の課題や、課題に対してのアドバイスをメモしましょう。</p>
              <TextArea class="l-formGroup__textArea is-highMiddle" v-model="workingAverage.resultMemo" @input="changeInput()" ></TextArea>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo" ref="memoEdit">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
              <button class="link-arrow is-normal js-memo-edit" @click="editMode()">編集する</button>
              <button class="link-arrow is-edit js-memo-exit" @click="editMode()">編集を終わる</button>
            </div>
            <p v-if="this.num==0" class="l-memo-note">今後どういった取り組みをしていくかをメモしましょう。<br>レポート画面からも入力できます。</p>
            <div class="l-contentsMemo__body">
              <div class="l-grayBox is-normal" style="min-height:108px;">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(workingAverage.actionMemo)"></p>
                </div>
              </div>
            </div>
            <TextArea class="l-formGroup__textArea is-highMiddle is-edit" v-model="workingAverage.actionMemo" @input="changeInput()"></TextArea>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2-->
  </div>
</template>

<script>
import TextBox from '@/components/parts/form/TextBox.vue';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import { numeric, between, maxLength } from 'vuelidate/lib/validators';
import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    TextBox,
    ValidationErrorMessage,
    TextArea,
    Currency,
  },
  props: {
    // 表示年度の労災発生件数データ
    workingAverage: {},
    num: null,
    monthArr: null,
  },
  data() {
    return {
      isAnswerChanged:false,
      unit1: "人",
      unit2: "時間",
      errObjRegularCountArr: [],
      errObjNonRegularCountArr: [],
      errObjLegalOutsideOvertimeArr: [],
      errObjLegalHolidayAttendanceArr: [],
    }
  },
  computed: {
    sumOfRegularCount() {
      if ( !(this.workingAverage.regularCount1!=null && this.workingAverage.regularCount2!=null && this.workingAverage.regularCount3!=null && this.workingAverage.regularCount4!=null && this.workingAverage.regularCount5!=null && this.workingAverage.regularCount6!=null && this.workingAverage.regularCount7!=null && this.workingAverage.regularCount8!=null && this.workingAverage.regularCount9!=null && this.workingAverage.regularCount10!=null && this.workingAverage.regularCount11!=null && this.workingAverage.regularCount12!=null ) ) {
        return null;
      }else if (( String(this.workingAverage.regularCount1).length * String(this.workingAverage.regularCount2).length * String(this.workingAverage.regularCount3).length * String(this.workingAverage.regularCount4).length * 
        String(this.workingAverage.regularCount5).length * String(this.workingAverage.regularCount6).length * String(this.workingAverage.regularCount7).length * String(this.workingAverage.regularCount8).length * String(this.workingAverage.regularCount9).length * 
        String(this.workingAverage.regularCount10).length * String(this.workingAverage.regularCount11).length * String(this.workingAverage.regularCount12).length ) == 0) {
        return null;
      }else if ( isNaN(this.workingAverage.regularCount1) || isNaN(this.workingAverage.regularCount2) || isNaN(this.workingAverage.regularCount3) || isNaN(this.workingAverage.regularCount4) || isNaN(this.workingAverage.regularCount5) || isNaN(this.workingAverage.regularCount6) || isNaN(this.workingAverage.regularCount7) || isNaN(this.workingAverage.regularCount8) || isNaN(this.workingAverage.regularCount9) || isNaN(this.workingAverage.regularCount10) || isNaN(this.workingAverage.regularCount11) || isNaN(this.workingAverage.regularCount12)) {
        return null;
      }else{
        return Number(this.workingAverage.regularCount1) + Number(this.workingAverage.regularCount2) + Number(this.workingAverage.regularCount3) + Number(this.workingAverage.regularCount4) + Number(this.workingAverage.regularCount5) + Number(this.workingAverage.regularCount6) + Number(this.workingAverage.regularCount7) + Number(this.workingAverage.regularCount8) + Number(this.workingAverage.regularCount9) + Number(this.workingAverage.regularCount10) + Number(this.workingAverage.regularCount11) + Number(this.workingAverage.regularCount12);
      }
    },
    sumOfNonRegularCount() {
      if ( !(this.workingAverage.nonRegularCount1!=null && this.workingAverage.nonRegularCount2!=null && this.workingAverage.nonRegularCount3!=null && this.workingAverage.nonRegularCount4!=null && this.workingAverage.nonRegularCount5!=null && this.workingAverage.nonRegularCount6!=null && this.workingAverage.nonRegularCount7!=null && this.workingAverage.nonRegularCount8!=null && this.workingAverage.nonRegularCount9!=null && this.workingAverage.nonRegularCount10!=null && this.workingAverage.nonRegularCount11!=null && this.workingAverage.nonRegularCount12!=null ) ) {
        return null;
      }else if ( (String(this.workingAverage.nonRegularCount1).length * String(this.workingAverage.nonRegularCount2).length * String(this.workingAverage.nonRegularCount3).length * String(this.workingAverage.nonRegularCount4).length *
       String(this.workingAverage.nonRegularCount5).length * String(this.workingAverage.nonRegularCount6).length * String(this.workingAverage.nonRegularCount7).length * String(this.workingAverage.nonRegularCount8).length * 
       String(this.workingAverage.nonRegularCount9).length * String(this.workingAverage.nonRegularCount10).length * String(this.workingAverage.nonRegularCount11).length * String(this.workingAverage.nonRegularCount12).length)==0) {
        return null;
      }else if ( isNaN(this.workingAverage.nonRegularCount1) || isNaN(this.workingAverage.nonRegularCount2) || isNaN(this.workingAverage.nonRegularCount3) || isNaN(this.workingAverage.nonRegularCount4) || isNaN(this.workingAverage.nonRegularCount5) || isNaN(this.workingAverage.nonRegularCount6) || isNaN(this.workingAverage.nonRegularCount7) || isNaN(this.workingAverage.nonRegularCount8) || isNaN(this.workingAverage.nonRegularCount9) || isNaN(this.workingAverage.nonRegularCount10) || isNaN(this.workingAverage.nonRegularCount11) || isNaN(this.workingAverage.nonRegularCount12)) {
        return null;
      }else{
        return Number(this.workingAverage.nonRegularCount1) + Number(this.workingAverage.nonRegularCount2) + Number(this.workingAverage.nonRegularCount3) + Number(this.workingAverage.nonRegularCount4) + Number(this.workingAverage.nonRegularCount5) + Number(this.workingAverage.nonRegularCount6) + Number(this.workingAverage.nonRegularCount7) + Number(this.workingAverage.nonRegularCount8) + Number(this.workingAverage.nonRegularCount9) + Number(this.workingAverage.nonRegularCount10) + Number(this.workingAverage.nonRegularCount11) + Number(this.workingAverage.nonRegularCount12);
      }
    },
    sumOfLegalOutsideOvertime() {
      if ( !(this.workingAverage.legalOutsideOvertime1!=null && this.workingAverage.legalOutsideOvertime2!=null && this.workingAverage.legalOutsideOvertime3!=null && this.workingAverage.legalOutsideOvertime4!=null && this.workingAverage.legalOutsideOvertime5!=null && this.workingAverage.legalOutsideOvertime6!=null && this.workingAverage.legalOutsideOvertime7!=null && this.workingAverage.legalOutsideOvertime8!=null && this.workingAverage.legalOutsideOvertime9!=null && this.workingAverage.legalOutsideOvertime10!=null && this.workingAverage.legalOutsideOvertime11!=null && this.workingAverage.legalOutsideOvertime12!=null ) ) {
        return null;
      }else if ( (String(this.workingAverage.legalOutsideOvertime1).length * String(this.workingAverage.legalOutsideOvertime2).length * String(this.workingAverage.legalOutsideOvertime3).length * String(this.workingAverage.legalOutsideOvertime4).length * 
      String(this.workingAverage.legalOutsideOvertime5).length * String(this.workingAverage.legalOutsideOvertime6).length * String(this.workingAverage.legalOutsideOvertime7).length * String(this.workingAverage.legalOutsideOvertime8).length * 
      String(this.workingAverage.legalOutsideOvertime9).length * String(this.workingAverage.legalOutsideOvertime10).length * String(this.workingAverage.legalOutsideOvertime11).length * String(this.workingAverage.legalOutsideOvertime12).length)==0) {
        return null;
      }else if ( isNaN(this.workingAverage.legalOutsideOvertime1) || isNaN(this.workingAverage.legalOutsideOvertime2) || isNaN(this.workingAverage.legalOutsideOvertime3) || isNaN(this.workingAverage.legalOutsideOvertime4) || isNaN(this.workingAverage.legalOutsideOvertime5) || isNaN(this.workingAverage.legalOutsideOvertime6) || isNaN(this.workingAverage.legalOutsideOvertime7) || isNaN(this.workingAverage.legalOutsideOvertime8) || isNaN(this.workingAverage.legalOutsideOvertime9) || isNaN(this.workingAverage.legalOutsideOvertime10) || isNaN(this.workingAverage.legalOutsideOvertime11) || isNaN(this.workingAverage.legalOutsideOvertime12)) {
        return null;
      }else{
        return Number(this.workingAverage.legalOutsideOvertime1) + Number(this.workingAverage.legalOutsideOvertime2) + Number(this.workingAverage.legalOutsideOvertime3) + Number(this.workingAverage.legalOutsideOvertime4) + Number(this.workingAverage.legalOutsideOvertime5) + Number(this.workingAverage.legalOutsideOvertime6) + Number(this.workingAverage.legalOutsideOvertime7) + Number(this.workingAverage.legalOutsideOvertime8) + Number(this.workingAverage.legalOutsideOvertime9) + Number(this.workingAverage.legalOutsideOvertime10) + Number(this.workingAverage.legalOutsideOvertime11) + Number(this.workingAverage.legalOutsideOvertime12);
      }
    },
    sumOfLegalHolidayAttendance() {
      if ( !(this.workingAverage.legalHolidayAttendance1!=null && this.workingAverage.legalHolidayAttendance2!=null && this.workingAverage.legalHolidayAttendance3!=null && this.workingAverage.legalHolidayAttendance4!=null && this.workingAverage.legalHolidayAttendance5!=null && this.workingAverage.legalHolidayAttendance6!=null && this.workingAverage.legalHolidayAttendance7!=null && this.workingAverage.legalHolidayAttendance8!=null && this.workingAverage.legalHolidayAttendance9!=null && this.workingAverage.legalHolidayAttendance10!=null && this.workingAverage.legalHolidayAttendance11!=null && this.workingAverage.legalHolidayAttendance12!=null ) ) {
        return null;
      }else if ( (String(this.workingAverage.legalHolidayAttendance1).length * String(this.workingAverage.legalHolidayAttendance2).length * String(this.workingAverage.legalHolidayAttendance3).length * String(this.workingAverage.legalHolidayAttendance4).length *  
      String(this.workingAverage.legalHolidayAttendance5).length * String(this.workingAverage.legalHolidayAttendance6).length * String(this.workingAverage.legalHolidayAttendance7).length * String(this.workingAverage.legalHolidayAttendance8).length * 
      String(this.workingAverage.legalHolidayAttendance9).length * String(this.workingAverage.legalHolidayAttendance10).length * String(this.workingAverage.legalHolidayAttendance11).length * String(this.workingAverage.legalHolidayAttendance12).length)==0) {
        return null;
      }else if ( isNaN(this.workingAverage.legalHolidayAttendance1) || isNaN(this.workingAverage.legalHolidayAttendance2) || isNaN(this.workingAverage.legalHolidayAttendance3) || isNaN(this.workingAverage.legalHolidayAttendance4) || isNaN(this.workingAverage.legalHolidayAttendance5) || isNaN(this.workingAverage.legalHolidayAttendance6) || isNaN(this.workingAverage.legalHolidayAttendance7) || isNaN(this.workingAverage.legalHolidayAttendance8) || isNaN(this.workingAverage.legalHolidayAttendance9) || isNaN(this.workingAverage.legalHolidayAttendance10) || isNaN(this.workingAverage.legalHolidayAttendance11) || isNaN(this.workingAverage.legalHolidayAttendance12)) {
        return null;
      }else{
        return Number(this.workingAverage.legalHolidayAttendance1) + Number(this.workingAverage.legalHolidayAttendance2) + Number(this.workingAverage.legalHolidayAttendance3) + Number(this.workingAverage.legalHolidayAttendance4) + Number(this.workingAverage.legalHolidayAttendance5) + Number(this.workingAverage.legalHolidayAttendance6) + Number(this.workingAverage.legalHolidayAttendance7) + Number(this.workingAverage.legalHolidayAttendance8) + Number(this.workingAverage.legalHolidayAttendance9) + Number(this.workingAverage.legalHolidayAttendance10) + Number(this.workingAverage.legalHolidayAttendance11) + Number(this.workingAverage.legalHolidayAttendance12);
      }
    },
    errorStatusRegularCount() {
      let workingAverageErrorArr = [this.$v.workingAverage.regularCount1.$invalid, this.$v.workingAverage.regularCount2.$invalid, this.$v.workingAverage.regularCount3.$invalid, this.$v.workingAverage.regularCount4.$invalid, this.$v.workingAverage.regularCount5.$invalid, this.$v.workingAverage.regularCount6.$invalid, this.$v.workingAverage.regularCount7.$invalid, this.$v.workingAverage.regularCount8.$invalid, this.$v.workingAverage.regularCount9.$invalid, this.$v.workingAverage.regularCount10.$invalid, this.$v.workingAverage.regularCount11.$invalid, this.$v.workingAverage.regularCount12.$invalid];
      var ret = false;
      for(let i = 0; i< 12; i++) ret = ret ||  workingAverageErrorArr[i];
      return ret;
    },
    errorStatusNonRegularCount() {
      let workingAverageErrorArr = [this.$v.workingAverage.nonRegularCount1.$invalid, this.$v.workingAverage.nonRegularCount2.$invalid, this.$v.workingAverage.nonRegularCount3.$invalid, this.$v.workingAverage.nonRegularCount4.$invalid, this.$v.workingAverage.nonRegularCount5.$invalid, this.$v.workingAverage.nonRegularCount6.$invalid, this.$v.workingAverage.nonRegularCount7.$invalid, this.$v.workingAverage.nonRegularCount8.$invalid, this.$v.workingAverage.nonRegularCount9.$invalid, this.$v.workingAverage.nonRegularCount10.$invalid, this.$v.workingAverage.nonRegularCount11.$invalid, this.$v.workingAverage.nonRegularCount12.$invalid];
      var ret = false;
      for(let i = 0; i< 12; i++) ret = ret ||  workingAverageErrorArr[i];
      return ret;
    },
    errorStatusLegalOutsideOvertime() {
      let errorObjectArr = [this.$v.workingAverage.legalOutsideOvertime1.$invalid, this.$v.workingAverage.legalOutsideOvertime2.$invalid, this.$v.workingAverage.legalOutsideOvertime3.$invalid, this.$v.workingAverage.legalOutsideOvertime4.$invalid, this.$v.workingAverage.legalOutsideOvertime5.$invalid, this.$v.workingAverage.legalOutsideOvertime6.$invalid, this.$v.workingAverage.legalOutsideOvertime7.$invalid, this.$v.workingAverage.legalOutsideOvertime8.$invalid, this.$v.workingAverage.legalOutsideOvertime9.$invalid, this.$v.workingAverage.legalOutsideOvertime10.$invalid, this.$v.workingAverage.legalOutsideOvertime11.$invalid, this.$v.workingAverage.legalOutsideOvertime12.$invalid]; 
      var ret = false;
      for(let i = 0; i< 12; i++) ret = ret ||  errorObjectArr[i];
      return ret;
    },
    errorStatusLegalHolidayAttendance() {
      let errorObjectArr = [this.$v.workingAverage.legalHolidayAttendance1.$invalid, this.$v.workingAverage.legalHolidayAttendance2.$invalid, this.$v.workingAverage.legalHolidayAttendance3.$invalid, this.$v.workingAverage.legalHolidayAttendance4.$invalid, this.$v.workingAverage.legalHolidayAttendance5.$invalid, this.$v.workingAverage.legalHolidayAttendance6.$invalid, this.$v.workingAverage.legalHolidayAttendance7.$invalid, this.$v.workingAverage.legalHolidayAttendance8.$invalid, this.$v.workingAverage.legalHolidayAttendance9.$invalid, this.$v.workingAverage.legalHolidayAttendance10.$invalid, this.$v.workingAverage.legalHolidayAttendance11.$invalid, this.$v.workingAverage.legalHolidayAttendance12.$invalid];
      var ret = false;
      for(let i = 0; i< 12; i++) ret = ret ||  errorObjectArr[i];
      return ret;
    },
    /**
     * 正社員カウントの数値チェック
     */
    errorStatusRegularCountNumeric() {
      var ret = false;
      for(let i = 0; i< 12; i++) { ret = ret || !this.errObjRegularCountArr[i].numeric;}
      return !ret;
    },
    /**
     * 正社員カウントの数値範囲チェック
     */
    errorStatusRegularCountBetween() {
      var ret = false;
      for(let i = 0; i< 12; i++) { ret = ret || !this.errObjRegularCountArr[i].between;}
      return !ret;
    },
    /**
     * 非正規社員カウントの数値チェック
     */
    errorStatusNonRegularCountNumeric() {
      var ret = false;
      for(let i = 0; i< 12; i++) { ret = ret || !this.errObjNonRegularCountArr[i].numeric;}
      return !ret;
    },
    /**
     * 非正規社員カウントの数値範囲チェック
     */
    errorStatusNonRegularCountBetween() {
      var ret = false;
      for(let i = 0; i< 12; i++) { ret = ret || !this.errObjNonRegularCountArr[i].between;}
      return !ret;
    },
    /**
     * 法定外残業（時間）の数値チェック
     */
    errorStatusLegalOutsideOvertimeNumeric() {
      var ret = false;
      for(let i = 0; i< 12; i++) { ret = ret || !this.errObjLegalOutsideOvertimeArr[i].numeric;}
      return !ret;
    },
    /**
     * 法定外残業（時間）の数値範囲チェック
     */
    errorStatusLegalOutsideOvertimeBetween() {
      var ret = false;
      for(let i = 0; i< 12; i++) { ret = ret || !this.errObjLegalOutsideOvertimeArr[i].between;}
      return !ret;
    },
    /**
     * 法定休日出勤（時間）の数値チェック
     */
    errorStatusLegalHolidayAttendanceNumeric() {
      var ret = false;
      for(let i = 0; i< 12; i++) { ret = ret || !this.errObjLegalHolidayAttendanceArr[i].numeric;}
      return !ret;
    },
    /**
     * 法定休日出勤（時間）の数値範囲チェック
     */
    errorStatusLegalHolidayAttendanceBetween() {
      var ret = false;
      for(let i = 0; i< 12; i++) { ret = ret || !this.errObjLegalHolidayAttendanceArr[i].between;}
      return !ret;
    },




  },
  validations: {
    workingAverage: {
      achievementWorkingHoursAverage : {
        between: between(0,999.9), 
        customDoubleNum: (value) => {
          if ( value != null && value.length == 0 ) return true;
          if ( value != null ) return /^([1-9][0-9]{0,3}|0)(\.[0-9]{1,1})?$/.test(value);
          return true;
        }
      }, // 休業3日以内
      regularWorkingHours : {
        between: between(0,9.99),
        customDoubleNum: (value) => {
          if ( value != null && value.length == 0 ) return true;
          if ( value != null ) return /^([1-9][0-9]{0,1}|0)(\.[0-9]{1,2})?$/.test(value);
          return true;
        }
      },  // 休業4日以上
      regularCount1 : { numeric, between: between(0, 99999) },
      regularCount2 : { numeric, between: between(0, 99999) },
      regularCount3 : { numeric, between: between(0, 99999) },
      regularCount4 : { numeric, between: between(0, 99999) },
      regularCount5 : { numeric, between: between(0, 99999) },
      regularCount6 : { numeric, between: between(0, 99999) },
      regularCount7 : { numeric, between: between(0, 99999) },
      regularCount8 : { numeric, between: between(0, 99999) },
      regularCount9 : { numeric, between: between(0, 99999) },
      regularCount10 : { numeric, between: between(0, 99999) },
      regularCount11 : { numeric, between: between(0, 99999) },
      regularCount12 : { numeric, between: between(0, 99999) },
      nonRegularCount1 : { numeric, between: between(0, 99999) },
      nonRegularCount2 : { numeric, between: between(0, 99999) },
      nonRegularCount3 : { numeric, between: between(0, 99999) },
      nonRegularCount4 : { numeric, between: between(0, 99999) },
      nonRegularCount5 : { numeric, between: between(0, 99999) },
      nonRegularCount6 : { numeric, between: between(0, 99999) },
      nonRegularCount7 : { numeric, between: between(0, 99999) },
      nonRegularCount8 : { numeric, between: between(0, 99999) },
      nonRegularCount9 : { numeric, between: between(0, 99999) },
      nonRegularCount10 : { numeric, between: between(0, 99999) },
      nonRegularCount11 : { numeric, between: between(0, 99999) },
      nonRegularCount12 : { numeric, between: between(0, 99999) },
      legalOutsideOvertime1 : { numeric, between: between(0, 9999999) },
      legalOutsideOvertime2 : { numeric, between: between(0, 9999999) },
      legalOutsideOvertime3 : { numeric, between: between(0, 9999999) },
      legalOutsideOvertime4 : { numeric, between: between(0, 9999999) },
      legalOutsideOvertime5 : { numeric, between: between(0, 9999999) },
      legalOutsideOvertime6 : { numeric, between: between(0, 9999999) },
      legalOutsideOvertime7 : { numeric, between: between(0, 9999999) },
      legalOutsideOvertime8 : { numeric, between: between(0, 9999999) },
      legalOutsideOvertime9 : { numeric, between: between(0, 9999999) },
      legalOutsideOvertime10 : { numeric, between: between(0, 9999999) },
      legalOutsideOvertime11 : { numeric, between: between(0, 9999999) },
      legalOutsideOvertime12 : { numeric, between: between(0, 9999999) },
      legalHolidayAttendance1 : { numeric, between: between(0, 9999999) },
      legalHolidayAttendance2 : { numeric, between: between(0, 9999999) },
      legalHolidayAttendance3 : { numeric, between: between(0, 9999999) },
      legalHolidayAttendance4 : { numeric, between: between(0, 9999999) },
      legalHolidayAttendance5 : { numeric, between: between(0, 9999999) },
      legalHolidayAttendance6 : { numeric, between: between(0, 9999999) },
      legalHolidayAttendance7 : { numeric, between: between(0, 9999999) },
      legalHolidayAttendance8 : { numeric, between: between(0, 9999999) },
      legalHolidayAttendance9 : { numeric, between: between(0, 9999999) },
      legalHolidayAttendance10 : { numeric, between: between(0, 9999999) },
      legalHolidayAttendance11 : { numeric, between: between(0, 9999999) },
      legalHolidayAttendance12 : { numeric, between: between(0, 9999999) },
      resultMemo: { maxLength: maxLength(300) }, // 実績メモ
      actionMemo: { maxLength: maxLength(300) }, // アクションメモ
    }
  },
  watch: {
    workingAverage() {
      this.inputWorkingAverage();
    }
  },
  created: function () {
  },
  mounted() {
    this.errObjRegularCountArr = [this.$v.workingAverage.regularCount1, this.$v.workingAverage.regularCount2, this.$v.workingAverage.regularCount3, this.$v.workingAverage.regularCount4, this.$v.workingAverage.regularCount5, this.$v.workingAverage.regularCount6, this.$v.workingAverage.regularCount7, this.$v.workingAverage.regularCount8, this.$v.workingAverage.regularCount9, this.$v.workingAverage.regularCount10, this.$v.workingAverage.regularCount11, this.$v.workingAverage.regularCount12];
    this.errObjNonRegularCountArr = [this.$v.workingAverage.nonRegularCount1, this.$v.workingAverage.nonRegularCount2, this.$v.workingAverage.nonRegularCount3, this.$v.workingAverage.nonRegularCount4, this.$v.workingAverage.nonRegularCount5, this.$v.workingAverage.nonRegularCount6, this.$v.workingAverage.nonRegularCount7, this.$v.workingAverage.nonRegularCount8, this.$v.workingAverage.nonRegularCount9, this.$v.workingAverage.nonRegularCount10, this.$v.workingAverage.nonRegularCount11, this.$v.workingAverage.nonRegularCount12];
    this.errObjLegalOutsideOvertimeArr = [this.$v.workingAverage.legalOutsideOvertime1, this.$v.workingAverage.legalOutsideOvertime2, this.$v.workingAverage.legalOutsideOvertime3, this.$v.workingAverage.legalOutsideOvertime4, this.$v.workingAverage.legalOutsideOvertime5, this.$v.workingAverage.legalOutsideOvertime6, this.$v.workingAverage.legalOutsideOvertime7, this.$v.workingAverage.legalOutsideOvertime8, this.$v.workingAverage.legalOutsideOvertime9, this.$v.workingAverage.legalOutsideOvertime10, this.$v.workingAverage.legalOutsideOvertime11, this.$v.workingAverage.legalOutsideOvertime12]; 
    this.errObjLegalHolidayAttendanceArr = [this.$v.workingAverage.legalHolidayAttendance1, this.$v.workingAverage.legalHolidayAttendance2, this.$v.workingAverage.legalHolidayAttendance3, this.$v.workingAverage.legalHolidayAttendance4, this.$v.workingAverage.legalHolidayAttendance5, this.$v.workingAverage.legalHolidayAttendance6, this.$v.workingAverage.legalHolidayAttendance7, this.$v.workingAverage.legalHolidayAttendance8, this.$v.workingAverage.legalHolidayAttendance9, this.$v.workingAverage.legalHolidayAttendance10, this.$v.workingAverage.legalHolidayAttendance11, this.$v.workingAverage.legalHolidayAttendance12];
  },
  methods: {
    inputWorkingAverage() {
      this.$emit("change-working-average", {
        workingAverage: this.workingAverage,
        num: this.num,
      });
    },
    // アクションメモの編集モード切替
    editMode(isEdit){
      const memoElm = this.$refs.memoEdit
      if ( isEdit == null || memoElm.classList.contains("is-edit") ){
        memoElm.classList.toggle("is-edit");
      }
    },
    // 文字列中のURLをaタグに変換する
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },
    // 編集フラグの取得（メイン画面の画面遷移時に呼び出されてチェックする）
    getIsAnswerChanged(){
      return this.isAnswerChanged; 
    },
    // 入力データ編集フラグ
    changeInput(){
      this.isAnswerChanged = true
    },
    setIsAnswerChanged(flag){
      this.isAnswerChanged = flag;
    },

    /**
     * 月別平均残業時間計算関数
     */
    calcWorkingAverage(num) {
      let regularCountArr    = [ this.workingAverage.regularCount1, this.workingAverage.regularCount2, this.workingAverage.regularCount3, this.workingAverage.regularCount4, this.workingAverage.regularCount5, this.workingAverage.regularCount6, 
                                  this.workingAverage.regularCount7, this.workingAverage.regularCount8, this.workingAverage.regularCount9, this.workingAverage.regularCount10, this.workingAverage.regularCount11, this.workingAverage.regularCount12];
      let nonRegularCountArr = [ this.workingAverage.nonRegularCount1, this.workingAverage.nonRegularCount2, this.workingAverage.nonRegularCount3, this.workingAverage.nonRegularCount4, this.workingAverage.nonRegularCount5, this.workingAverage.nonRegularCount6, 
                              this.workingAverage.nonRegularCount7, this.workingAverage.nonRegularCount8, this.workingAverage.nonRegularCount9, this.workingAverage.nonRegularCount10, this.workingAverage.nonRegularCount11, this.workingAverage.nonRegularCount12];
      let legalOutsideOvertimeArr = [ this.workingAverage.legalOutsideOvertime1, this.workingAverage.legalOutsideOvertime2, this.workingAverage.legalOutsideOvertime3, this.workingAverage.legalOutsideOvertime4, this.workingAverage.legalOutsideOvertime5, this.workingAverage.legalOutsideOvertime6, 
                                  this.workingAverage.legalOutsideOvertime7, this.workingAverage.legalOutsideOvertime8, this.workingAverage.legalOutsideOvertime9, this.workingAverage.legalOutsideOvertime10, this.workingAverage.legalOutsideOvertime11, this.workingAverage.legalOutsideOvertime12];
      let legalHolidayAttendanceArr = [ this.workingAverage.legalHolidayAttendance1, this.workingAverage.legalHolidayAttendance2, this.workingAverage.legalHolidayAttendance3, this.workingAverage.legalHolidayAttendance4, this.workingAverage.legalHolidayAttendance5, this.workingAverage.legalHolidayAttendance6, 
                                  this.workingAverage.legalHolidayAttendance7, this.workingAverage.legalHolidayAttendance8, this.workingAverage.legalHolidayAttendance9, this.workingAverage.legalHolidayAttendance10, this.workingAverage.legalHolidayAttendance11, this.workingAverage.legalHolidayAttendance12];

      var value1 = (num != null) ? regularCountArr[num] : this.sumOfRegularCount;
      var value2 = (num != null) ? nonRegularCountArr[num] : this.sumOfNonRegularCount;
      var value3 = (num != null) ? legalOutsideOvertimeArr[num] : this.sumOfLegalOutsideOvertime;
      var value4 = (num != null) ? legalHolidayAttendanceArr[num] : this.sumOfLegalHolidayAttendance;

      if ( !(value1!=null && value2!=null && value3!=null && value4!=null ) ) {
        return null;
      }else if ( (value1.length * value2.length * value3.length * value4.length)==0 ) {
        return null;
      }else if ( isNaN(value1) || isNaN(value2) || isNaN(value3) || isNaN(value4) ) {
        return null;
      }else{
        let sum1 = Number(value1) + Number(value2);
        let sum2 = Number(value3) + Number(value4);
        if ( sum1 != null && sum2 != null ){
          if ( sum2 == 0 ) return 0;
          if ( sum1 == 0 ) return null;
          let val = (sum2 / sum1) * 10; // 小数点以下１まで表示なので10
          let ret =  Math.round(val)/10;
          if ( num == null ) {
            this.workingAverage.achievementWorkingHoursAverage = ret;
          }
          return ret;
        }else{
          return null;
        }
      }
    },
  }
}

</script>
